import { useState, Fragment, useRef, Suspense, useCallback, useEffect, useContext } from "react";
import { ThemeContext } from "../../../../../contexts";

import { Grid, Backdrop, makeStyles } from "@material-ui/core";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { useReactToPrint } from "react-to-print";
import { api } from "../../../../../utils/api";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import KsopFormActual from "./ksopFormActual/KsopFormActual";
import KsopFormPrint from "./ksopFormPrint/KsopFormPrint";

import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";

import "./ksopForm.css";
import { trackPromise } from "react-promise-tracker";

/* eslint-disable */
const useStyles = makeStyles((theme) => ({
	root: {
		height: 380,
		transform: "translateZ(0px)",
		flexGrow: 1
	},
	alert: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2)
		}
	},
	speedDial: {
		position: "fixed",
		bottom: theme.spacing(2),
		right: theme.spacing(2)
	}
}));

const KsopForm = () => {
	const [primaryBeneficiary, setPrimaryBeneficiary] = useState([1, 2, 3, 4]);
	const [contingentBeneficiary, setContingentBeneficiary] = useState([1, 2, 3, 4]);
	const [enrollments, setEnrollments] = useState([]);
	const [planName, setPlanName] = useState("");
	const [enrollmentStatus, setEnrollmentStatus] = useState("");
	const [enrollmentDate, setEnrollmentDate] = useState("");
	const [effectiveDate, setEffectiveDate] = useState("");
	const { setTheme } = useContext(ThemeContext);
	const [openSpeedDial, setOpenSpeedDial] = useState(false);
	const [valueChange, setValueChange] = useState(false);
	const queryPlanCode = useRouteParam("pc");
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const componentRef = useRef(null);
	const handlePrint = useReactToPrint({
		content: () => componentRef.current
	});
	const classes = useStyles();
	const speedDialActions = [
		{
			icon: <GetAppIcon />,
			name: "Download",
			callback: handlePrint
		},
		{
			icon: <PublishIcon />,
			name: "Submit"
		}
	];

	const handleOpenSpeedDial = () => setOpenSpeedDial(true);

	const handleCloseSpeedDial = () => setOpenSpeedDial(false);

	// eslint-disable-next-line arrow-parens
	const handleApproveEffectiveDateChange = useCallback((_date) => {
		const date = new Date(_date);
		const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
		setEffectiveDate(parsedDate);
	}, []);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
			return;
		}

		const query = {
			insured_SSN: querySSN,
			plan_code: queryPlanCode,
			group_number: queryGroupNumber,
			enrollment_status: "ACTIVE"
		};
		const { enrollments, theme } = await trackPromise(api.pages.getAdminEnrollmentInitData(query));
		setEnrollments(Object.assign([], enrollments[0]));
		const { enrollment_status, enrollment_date, plan_name } = enrollments[0];
		setTheme(Object.assign({}, theme));
		setEnrollmentDate(enrollment_date);
		setEnrollmentStatus(enrollment_status);
		setPlanName(plan_name);
	}, [queryGroupNumber, queryPlanCode, querySSN]);

	// console.log("KSOP", enrollments);
	// console.log(queryGroupNumber);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	return (
		<div className="ksop-root-container">
			<Backdrop open={openSpeedDial} style={{ zIndex: 1009 }} />
			<SpeedDial
				ariaLabel="SpeedDial"
				className={` ${classes.speedDial}`}
				icon={<SpeedDialIcon />}
				sx={{ position: "fixed", bottom: 16, right: 16 }}
				onClose={handleCloseSpeedDial}
				onOpen={handleOpenSpeedDial}
				open={openSpeedDial}
				FabProps={{
					sx: {
						bgcolor: "green",
						"&:hover": {
							bgcolor: "secondary.main"
						}
					}
				}}
			>
				{speedDialActions.map((action, index) => {
					const { name, icon, callback } = action;
					return (
						<SpeedDialAction key={index} icon={icon} tooltipTitle={name} tooltipOpen onClick={callback} />
					);
				})}
			</SpeedDial>

			{enrollments ? (
				<>
					<KsopFormActual
						// primaryBeneficiary={primaryBeneficiary}
						// contingentBeneficiary={contingentBeneficiary}
						enrollments={enrollments}
						enrollmentDate={enrollmentDate}
						enrollmentStatus={enrollmentStatus}
						effectiveDate={effectiveDate}
						handleApproveEffectiveDateChange={handleApproveEffectiveDateChange}
						planName={planName}
					/>

					<div style={{ display: "none" }}>
						<Suspense fallback={<div />}>
							<KsopFormPrint
								primaryBeneficiary={primaryBeneficiary}
								contingentBeneficiary={contingentBeneficiary}
								enrollments={enrollments}
								ref={componentRef}
							/>
						</Suspense>
					</div>
				</>
			) : null}
		</div>
	);
};

export default KsopForm;
